var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(892 2201)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-887 -2196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,2a11,11,0,0,1,7.778,18.778A11,11,0,0,1,5.222,5.222,10.928,10.928,0,0,1,13,2Zm0,20a9,9,0,1,0-9-9A9.01,9.01,0,0,0,13,22Z",
    transform: "translate(-3 -3)",
    fill: "#809fb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,18a1,1,0,0,1-.446-.106l-4-2A1,1,0,0,1,17,15V9a1,1,0,0,1,2,0v5.382l3.447,1.724A1,1,0,0,1,22,18Z",
    transform: "translate(-8 -5)",
    fill: "#809fb8"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-892 -2201)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/Hours.97ab82b68831d0cd47c3e210f0067c07.svg";
export { ForwardRef as ReactComponent };